import { __awaiter, __extends, __generator } from "tslib";
import AdobeAnalyticsDtmClient from "../../../adobeAnalytics/AdobeAnalyticsDtmClient";
import RequestTypes from "../../RequestTypes";
import AbstractAdapter from "./AbstractAdapter";
/**
 * Adobe analytics DTM adapter
 */
var Dtm = /** @class */ (function (_super) {
    __extends(Dtm, _super);
    function Dtm(config) {
        var _this = _super.call(this, config) || this;
        _this.clientOrConfig = config.client;
        return _this;
    }
    Dtm.prototype._record = function (request, rawRequest) {
        return __awaiter(this, void 0, void 0, function () {
            var adapter, response, client, setRequest, value, trackRequest, source, action, label, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getName()];
                    case 1:
                        adapter = _a.sent();
                        response = {
                            adapter: adapter,
                            finalRequest: request,
                            isResponseConfirmed: false,
                            isSuccess: true,
                        };
                        try {
                            if (JSON.stringify(request) !== JSON.stringify(rawRequest)) {
                                response.rawRequest = rawRequest;
                            }
                        }
                        catch (error) { }
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.getClient()];
                    case 3:
                        client = _a.sent();
                        switch (request.type) {
                            case RequestTypes.Alias:
                                throw new Error("Not implemented");
                            case RequestTypes.Set:
                                setRequest = request;
                                value = String(setRequest.properties.value);
                                client.set(value);
                                break;
                            case RequestTypes.Identity:
                                throw new Error("Not implemented");
                            case RequestTypes.Page:
                                throw new Error("Not implemented");
                            case RequestTypes.Track:
                                trackRequest = request;
                                source = trackRequest.properties.source;
                                action = trackRequest.event;
                                label = source || "";
                                client.sendEvent(action, {
                                    label: label,
                                }, { label: label });
                                response.meta = {
                                    event: action,
                                    label: label,
                                };
                                break;
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        response.error = error_1;
                        response.isSuccess = false;
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/, response];
                }
            });
        });
    };
    Dtm.prototype.getName = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, "Dtm"];
            });
        });
    };
    Dtm.prototype.getClient = function () {
        return __awaiter(this, void 0, void 0, function () {
            var clientOrConfig;
            return __generator(this, function (_a) {
                if (!this.client) {
                    clientOrConfig = this.clientOrConfig;
                    this.client =
                        this.clientOrConfig instanceof AdobeAnalyticsDtmClient
                            ? clientOrConfig
                            : new AdobeAnalyticsDtmClient(clientOrConfig);
                }
                return [2 /*return*/, this.client];
            });
        });
    };
    return Dtm;
}(AbstractAdapter));
export default Dtm;
//# sourceMappingURL=Dtm.js.map